export function enterpriseLastMileDelivery(entity) {
  const cs = (entity || {}).content_settings || {};
  if (cs.hasOwnProperty('enterprise_last_mile_delivery')) {
    return !!cs.enterprise_last_mile_delivery;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./app/utils/content-settings.js